'use client';

import { Cookie } from '@phosphor-icons/react';

/**
 * Re-opens the cookie consent banner. Dispatches a global event the
 * provider listens for, so this button works from anywhere in the tree
 * without needing to be a descendant of `CookieBannerProvider` directly
 * (the event listener is attached at the window level).
 */
export function ManageCookiesButton({
  className,
  label = 'Manage cookie preferences',
}: {
  className?: string;
  label?: string;
}) {
  return (
    <button
      type="button"
      onClick={() => window.dispatchEvent(new Event('open-cookie-settings'))}
      className={
        className ??
        'border-brand-200 text-brand-700 hover:bg-brand-50 hover:border-brand-300 inline-flex items-center gap-2 rounded-full border bg-white px-4 py-2 text-sm font-medium transition'
      }
    >
      <Cookie size={16} aria-hidden />
      {label}
    </button>
  );
}
